<div class="absolute inset-0 flex flex-col min-w-0 overflow-hidden dms-fm-container"
#fileManagerContainer>

    <mat-drawer-container class="flex-auto h-full">

        <!-- Drawer -->
       
        <mat-drawer 
            *ngIf="!defaultView"
            class="w-72 dark:bg-gray-900 dms-file-drawer"
            [autoFocus]="false"
            [mode]="drawerMode"
            [opened]="drawerOpened"
            #fileManagerDrawer>
            <file-manager-sidebar></file-manager-sidebar>
        </mat-drawer>

        <!-- Drawer content -->
        <mat-drawer-content class="flex flex-col overflow-hidden">

            <!-- Main -->
            <div class="flex flex-auto overflow-hidden">
               
                <router-outlet></router-outlet>
              
            </div>

        </mat-drawer-content>

    </mat-drawer-container>
    <!--Alert - item moved to trash-->
    <fuse-alert class="custom-fuse-alert"
        [appearance]="'outline'"
        [dismissible]="true"
        [dismissed]="true"
        [name]="'alert_trash'"
        [type]="'warning'">
        <span fuseAlertTitle>{{ 'Trash' | lpmLabel:'trashLocationLabel' }}</span>
        Item moved to trash
    </fuse-alert>
     <!--Alert - items deleted from trash-->
    <fuse-alert class="custom-fuse-alert"
        [appearance]="'outline'"
        [dismissible]="true"
        [dismissed]="true"
        [name]="'alert_delete_multi'"
        [type]="'warn'">
        <span fuseAlertTitle>Delete</span>
        Multiple items deleted from trash permanently!
    </fuse-alert>
    <!--Alert - item deleted from trash-->
    <fuse-alert class="custom-fuse-alert"
        [appearance]="'outline'"
        [dismissible]="true"
        [dismissed]="true"
        [name]="'alert_delete'"
        [type]="'warn'">
        <span fuseAlertTitle>Delete</span>
        Item deleted from trash permanently!
    </fuse-alert>
     <!--Alert - items moved to trash-->
    <fuse-alert class="custom-fuse-alert"
        [appearance]="'outline'"
        [dismissible]="true"
        [dismissed]="true"
        [name]="'alert_trash_multi'"
        [type]="'warning'">
        <span fuseAlertTitle>{{ 'Trash' | lpmLabel:'trashLocationLabel' }}</span>
        Multiple items moved to trash!
    </fuse-alert>
    <!--Alert - item downloaded-->
    <fuse-alert class="custom-fuse-alert"
        [appearance]="'outline'"
        [dismissible]="true"
        [dismissed]="true"
        [name]="'alert_download'"
        [type]="'success'">
        <span fuseAlertTitle>Download</span>
        Item successfully downloaded
    </fuse-alert>
    <!--Alert - items downloaded-->
    <fuse-alert class="custom-fuse-alert"
        [appearance]="'outline'"
        [dismissible]="true"
        [dismissed]="true"
        [name]="'alert_download_multi'"
        [type]="'success'">
        <span fuseAlertTitle>Download</span>
        Items successfully downloaded in a zip file
    </fuse-alert>
     <!--Alert - item restored-->
     <fuse-alert class="custom-fuse-alert"
        [appearance]="'outline'"
        [dismissible]="true"
        [dismissed]="true"
        [name]="'alert_restore'"
        [type]="'success'">
        <span fuseAlertTitle>Restored</span>
        Item(s) successfully restored!
    </fuse-alert>
    <!--file uploader queue widget-->
    <!--
    -->
    <!--<notifier-container></notifier-container>-->
</div>




